import styled from 'styled-components';
import css from '@styled-system/css';
import { Container } from 'ui/core';

export const PillContainer = styled(Container)`
  ${css({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    border: 'black',
    borderRadius: 'large',
    width: 'fit-content',
    padding: 'tiny',
    paddingX: 'tiny',
    ':hover': {
      cursor: 'pointer',
    },
    margin: 'tiny',
  })}
`;
